import React from "react";

export const Logo = ({ size = "text-6xl", showTagline = false }) => (
  <div className="flex flex-col items-center gap-3" data-testid="well-logo">
    <h1 className={`${size} font-bold tracking-tight text-[#2A3B32]`}>Well</h1>
    {showTagline && (
      <p className="text-lg font-light italic text-[#4A5D52]">Support that stays with you</p>
    )}
  </div>
);

export default Logo;
